/** Creating a new axios client to use in the app
 *  defining a base route for the client and axios itself
 *  enabling credentials
 */
import axios from "axios";
import * as Sentry from "@sentry/react";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { Clipboard, ClipboardCheck } from "react-bootstrap-icons";
import { useState } from "react";
import { Badge } from "react-bootstrap";

axios.defaults.baseURL = import.meta.env.VITE_AXIOS;
axios.defaults.withCredentials = true;

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_AXIOS,
  withCredentials: true,
});

axiosClient.defaults.baseURL = import.meta.env.VITE_AXIOS;
axiosClient.defaults.withCredentials = true;

axiosClient.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.setItem("_af", 1);
    }

    console.log("sending to sentry...");
    const errorCode = `AX-${uuidv4().slice(0, 5).toUpperCase()}`;

    const axiosErrorInfo = {
      message: error.message,
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      responseData: error.response?.data,
      requestData: error.config?.data,
    };

    Sentry.captureException(error, {
      tags: { errorCode },
      extra: axiosErrorInfo,
    });

    const ToastComponent = () => {
      const [copied, setCopied] = useState(false);

      return (
        <span>
          <b
            dangerouslySetInnerHTML={{
              __html:
                error?.response?.data?.detail?.error ||
                "Something went wrong. Please contact system admin.",
            }}
          ></b>
          <br />
          <br />
          <div className="fw-normal" style={{ fontSize: "0.9rem" }}>
            <span>Code: {errorCode}</span>
            <Badge
              className={`mx-1 border ${
                copied
                  ? "border-success text-success"
                  : "border-secondary text-secondary cursor-pointer"
              }`}
              bg="light"
              pill
            >
              {!copied && (
                <span
                  onClick={() => {
                    navigator.clipboard.writeText(errorCode);
                    setCopied(true);
                  }}
                >
                  <Clipboard size={15} /> Copy Code
                </span>
              )}
              {copied && (
                <span>
                  <ClipboardCheck size={15} /> Copied!
                </span>
              )}
            </Badge>
          </div>
        </span>
      );
    };

    toast.error(<ToastComponent />);

    return Promise.reject(error);
  }
);

export default axiosClient;
